import { render, staticRenderFns } from "./table-pagination.vue?vue&type=template&id=20ee1f1e&scoped=true"
import script from "./table-pagination.vue?vue&type=script&lang=ts"
export * from "./table-pagination.vue?vue&type=script&lang=ts"
import style0 from "./table-pagination.vue?vue&type=style&index=0&id=20ee1f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ee1f1e",
  null
  
)

export default component.exports